import { useLocation, useNavigate, useParams } from "react-router";
import { Path } from "../path";

export const SCOPE_TAB = "scope";
export const ASSUMPTIONS_TAB = "assumptions";
export const EXCLUSIONS_TAB = "exclusions";
export const DISBURSEMENTS_TAB = "disbursements";
export const TECHNOLOGY_TAB = "technology";
export const UPLIFTS_TAB = "uplifts";
export const DISCOUNTS_TAB = "discounts";
export const CLIENT_MATTER_DETAILS = "clientmatterdetails";
export const PRICING_STRUCTURE = "pricingstructure";
export const FEE_RISK_PROFILE_TAB = "feeriskprofile";
export const TEAM_TAB = "team";
export const TOP_DOWN_PRICING_TAB = "topdownpricing";
export const PROPOSAL_PREVIEW_TAB = "proposalpreview";
export const HISTORICAL_MATTERS_TAB = "historicalmatters";
export const TIMELINE_TAB = "timeline";
export const DEFAULT_ACTIVE_TAB = SCOPE_TAB;
const TAB_KEYS = [
  SCOPE_TAB,
  ASSUMPTIONS_TAB,
  EXCLUSIONS_TAB,
  DISBURSEMENTS_TAB,
  UPLIFTS_TAB,
  DISCOUNTS_TAB,
  TECHNOLOGY_TAB,
  PRICING_STRUCTURE,
  CLIENT_MATTER_DETAILS,
  TEAM_TAB,
  TOP_DOWN_PRICING_TAB,
  FEE_RISK_PROFILE_TAB,
  PROPOSAL_PREVIEW_TAB,
  HISTORICAL_MATTERS_TAB,
  TIMELINE_TAB,
];

export type TAB_KEYS_T = typeof TAB_KEYS;
export type VPDTab = typeof TAB_KEYS[number];
const isValidTabKey = (tabKey: string): tabKey is VPDTab => {
  return TAB_KEYS.includes(tabKey);
};
const DEFAULT_BASE_PATH = Path.MATTER_EDITOR_BASE_PATH;

export function useActiveTabState(
  defaultActiveTab: VPDTab = DEFAULT_ACTIVE_TAB,
  basePath?: typeof Path.MATTER_EDITOR_BASE_PATH | typeof Path.MATTER_TEMPLATE_EDITOR_BASE_PATH
): [string, (newActiveTab: VPDTab) => void] {
  const { pathname } = useLocation();
  const { matterId } = useParams();
  const navigate = useNavigate();

  const id = parseInt(matterId || "");
  const path = pathname.split("/");
  const activeTab = path.length > 3 ? path[path.length - 1] : defaultActiveTab;
  const onChangeTab = (newActiveTab: VPDTab) =>
    isValidTabKey(newActiveTab)
      ? navigate(`/${basePath || DEFAULT_BASE_PATH}/${id}/${newActiveTab}`)
      : navigate(`/${basePath || DEFAULT_BASE_PATH}/${id}`);

  return [isValidTabKey(activeTab) ? activeTab : defaultActiveTab, onChangeTab];
}
